import React, { useState, useEffect } from "react"
import { fireStore, auth } from "../firebase/firebase"
import { motion } from "framer-motion"
import { useStore } from "../context/context"
import { useAuth, useAuthActions } from "../firebase/useAuth"
import { Visibility, VisibilityOff } from "@material-ui/icons"
import { useHistory } from "react-router-dom"

export default function Settings() {
  const [currentUser] = useAuth()
  const userRef = fireStore.collection("users").doc(currentUser?.uid)
  const user = auth.currentUser
  const { logout } = useAuthActions({})
  const { dispatch } = useStore()
  const history = useHistory()

  const [username, setUsername] = useState(currentUser?.displayName)
  const [email, setEmail] = useState(currentUser?.email)
  const [password, setPassword] = useState("")
  const [repeatPassword, setRepeatPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [showRepeatPassword, setShowRepeatPassword] = useState(false)
  const [hasMadeChanges, setHasMadeChanges] = useState(false)
  const [subscriptionType, setSubscriptionType] = useState(currentUser?.subscriptionType)
  const [error, setError] = useState(null)

  useEffect(() => {
    setUsername(currentUser?.displayName)
    setEmail(currentUser?.email)
    setSubscriptionType(currentUser?.subscriptionType)
  }, [currentUser])

  useEffect(() => {
    if(
      username !== currentUser?.displayName
      || email !== currentUser?.email
      || password !== "" && repeatPassword !== ""
      ) {
      setHasMadeChanges(true)
    } else {
      setHasMadeChanges(false)
    }
  }, [username, email, password, repeatPassword])

  useEffect(() => { setTimeout(() => setError(null), 4500) }, [error])


  const saveChanges = () => {
    const updateUserNameAndMail = () => {
      user.updateProfile({ displayName: username }).then(() => {
        user.updateEmail(email).then(() => {
          userRef.update({
            displayName: username,
            email: email
          }).then(() => {
            dispatch({ type: "SET_NOTIFICATION", payload: "Vos information ont bien été modifiées" })
          }).catch(err => setError(err))
        }).catch(err => setError(err))
      }).catch(err => setError(err))
    }

    if(password !== repeatPassword) return setError("Les mots de passe ne match pas")
    if(password.length === 0) return updateUserNameAndMail()
    if(password.length < 5 || password.length > 20) return setError("Le mot de passe doit faire entre 5 et 20 caractères")

    updateUserNameAndMail()
    user.updatePassword(password)
      .then(() => dispatch({ type: "SET_NOTIFICATION", payload: "Vos information ont bien été modifiées" }))
      .catch(err => setError(err))
  }

  const changeSubscription = () => {
    if(subscriptionType === "premium") {
      history.push("/premiumform")
    } else if(subscriptionType === "free") {
      history.push("/freecomfirmation")
    }
  }


	return (
		<motion.div className="settings" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <div className="row">
        <div className="col userInfos">
          <h2 className="categoryTitle">Vos informations personnelles</h2>
          <div className="infoGroup">
            <label className="label" htmlFor="username">Votre nom d'utilisateur</label>
            <input 
              type="text" 
              className="input" 
              id="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
          </div>
          <div className="infoGroup">
            <label className="label" htmlFor="email">Votre adresse email</label>
            <input 
              type="email" 
              className="input" 
              id="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="infoGroup">
            <label className="label" htmlFor="password">Nouveau mot de passe</label>
            <div className="relativeContainer">
              <input 
                type={showPassword ? "text" : "password"} 
                className="input" 
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <span 
                className="eyePassword" 
                onClick={_ => setShowPassword(ps => !ps)}
                title={showPassword ? "Cacher le mot de passe" : "Voir le mot de passe"}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </span>
            </div>
          </div>
          <div className="infoGroup">
            <label className="label" htmlFor="repeatPassword">Répétez le mot de passe</label>
            <div className="relativeContainer">
              <input 
                type={showRepeatPassword ? "text" : "password"} 
                className="input" 
                id="repeatPassword"
                value={repeatPassword}
                onChange={e => setRepeatPassword(e.target.value)}
              />
              <span 
                className="eyePassword" 
                onClick={_ => setShowRepeatPassword(ps => !ps)}
                title={showRepeatPassword ? "Cacher le mot de passe" : "Voir le mot de passe"}
              >
                {showRepeatPassword ? <Visibility /> : <VisibilityOff />}
              </span>
            </div>
          </div>
          {error && <div className="error">
            ⚠ {typeof error === "object" ? JSON.stringify(error) : error}
          </div>}
          <div className="row">
            <button className={`btn saveChangesBtn ${!hasMadeChanges && "disabled"}`} disabled={!hasMadeChanges} onClick={saveChanges}>Enregistrer les modifications</button>
            <button className="btn danger saveChangesBtn logoutBtn" onClick={logout}>Se déconnecter</button>
          </div>
        </div>

        <div className="col subscriptionInfos">
          <h2 className="categoryTitle">Votre abonnement</h2>
          <div className="optionsGroup">
            <div className="option" onClick={() => setSubscriptionType("free")}>
              <div className="row">
                <input 
                  type="radio" 
                  name="subscription" 
                  value="free_subscription" 
                  checked={subscriptionType === "free"} 
                  id="freeSub" 
                  className="input"
                />
                <label htmlFor="freeSub" className="label">Abonnement gratuit - 8 posts</label>
              </div>
              <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat qui tempora ullam exercitationem est alias dicta porro quisquam reprehenderit atque odit itaque saepe illo, nihil maiores fuga architecto. Doloribus quae a sint. Rem, nisi! Sequi molestiae quibusdam, velit autem aspernatur in dolores quia, labore modi ullam repellat! Autem, tempore. Nulla?</p>
            </div>
            <div className="option" onClick={() => setSubscriptionType("premium")}>
              <div className="row">
                <input 
                  type="radio" 
                  name="subscription" 
                  value="premium_subscription"
                  checked={subscriptionType === "premium"} 
                  id="paySub" 
                  className="input"
                />
                <label htmlFor="paySub" className="label">Abonnement premium - 75 posts</label>
              </div>
              <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat qui tempora ullam exercitationem est alias dicta porro quisquam reprehenderit atque odit itaque saepe illo, nihil maiores fuga architecto. Doloribus quae a sint. Rem, nisi! Sequi molestiae quibusdam, velit autem aspernatur in dolores quia, labore modi ullam repellat! Autem, tempore. Nulla?</p>
            </div>
          </div>
          <button 
            className={`
              btn danger saveChangesBtn 
              ${subscriptionType === currentUser?.subscriptionType && "disabled"}`
            }
            disabled={subscriptionType === currentUser?.subscriptionType}
            onClick={changeSubscription}
          >Valider le nouvel abonnement</button>
        </div>
      </div>
		</motion.div>
	)
}
